import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IForm } from "commons/ultilities/dynamic-form/models/form";
import { IAddPaperGoodsIssue } from "mobx-stores/_models/paper-inventory/paper-goods-issue/paper-goods-issue";
import { date } from "yup";
import { getGoodsIssueItemsArraySchema } from "../goods-issue-schema-shared";

export const getAddPaperGoodsIssueSchema = (
  form: IForm,
): ObjectSchemaType<IAddPaperGoodsIssue> => ({
  issueDate: {
    type: InputType.datePicker,
    gridSize: 12,
    label: "Ngày xuất",
    validattionYupSchema: date().required(),
  },

  items: {
    arraySchema: getGoodsIssueItemsArraySchema(),
  },
});
